<script>
import CMSSinglePage from "@/views/components/cms/CMSSinglePage.vue";

export default {
  name: "Abrechnung",
  components: {CMSSinglePage},
}
</script>

<template>
 <CMSSinglePage list-element="AbrechnungList"></CMSSinglePage>
</template>

<style scoped>

</style>
